import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOtherExpanceIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.28516 9.60156H27.7083",
			stroke: "#003F8C",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.28516 16.3496H27.7083",
			stroke: "#003F8C",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.28516 23.0967H16.4724",
			stroke: "#003F8C",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1113 23.0967H27.7138",
			stroke: "#003F8C",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4121 19.7959L24.4121 26.3983",
			stroke: "#003F8C",
			strokeLinecap: "round"
		})
	]
});
export default SvgOtherExpanceIcon;
